import {ISelectionOptions, Selection} from 'components/FluentUICompat';
import * as React from 'react';

const areSelectionsEqual = <T>(previous: T[], next: T[]) => {
	if (previous.length !== next.length) {
		return false;
	}

	return previous.every((item, index) => item === next[index]);
};

export type SettingsType = 'list';

export function useSelection<T>({
	getKey,
	...options
}: Omit<ISelectionOptions, 'getKey' | 'onSelectionChanged'> & {
	getKey?: (item: T) => string;
	onSelectionChanged?: (selectedItems: T[], selection: Selection) => void;
} = {}) {
	const [selectedItems, setSelectedItems] = React.useState<T[]>([]);
	const selectedItemsRef = React.useRef<T[]>([]);
	const selection = React.useRef(
		(() => {
			const self = new Selection({
				...options,
				getKey: getKey ? (getKey as any) : undefined,
				onSelectionChanged() {
					const nextSelectedItems = self.getSelection() as T[];

					if (areSelectionsEqual(selectedItemsRef.current, nextSelectedItems)) {
						return;
					}

					selectedItemsRef.current = nextSelectedItems;
					setSelectedItems(nextSelectedItems);
					options.onSelectionChanged?.(nextSelectedItems, self);
				},
			});

			return self;
		})(),
	);

	return [selection.current, selectedItems] as [Selection, T[]];
}

export default useSelection;
